import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const HsocMerchCardBadge = ({
  badge
}) => {
  if (badge === 'recommended') {
    return /*#__PURE__*/_jsx(Badge, {
      use: "sorbet",
      alignSelf: "center",
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "heading-25",
        textWrap: "nowrap",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hsocPricingPage.badge.recommended"
        })
      })
    });
  }
  if (badge === 'current') {
    return /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      alignSelf: "center",
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "heading-25",
        textWrap: "nowrap",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hsocPricingPage.badge.current"
        })
      })
    });
  }
  return null;
};